import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect, useRef, useState } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import Image from "../../assets/Images/InvoiceImg1.svg";
import { useNavigate } from "react-router-dom";
import { BatchCardIcon } from "../../assets/Icon/headerCicon";
import ListLoadingNew from "../common-components/ListLoadingNew";
import {
  buyInvoicePlan,
  getCustomInvoices,
  getInvoiceList,
  getInvoicePlans,
  sendStripeCode,
} from "../../stores/clients";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setToast } from "../../stores/toast/toastslice";

const InvoicePlanPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isActive = useRef(true);
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isLargeScreen = useMediaQuery("(max-width:1440px)");
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [plans, setPlans] = useState<any>(null);
  const [isRenew, setIsRenew] = useState(false);
  const [isPending, setIsPending] = useState(false);

  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  const { data, clientListStatus, total_records, error } = useSelector(
    (state: any) => state.clients,
  );

  const [page, setPage] = useState("setup");
  const [stripeCodeLoader, setStripeCodeLoader] = useState(false);

  const handleBuyPlan = async (id: string) => {
    setBtnLoading(true);
    try {
      const response = await dispatch<any>(
        buyInvoicePlan({ plan_id: id?.toString() }),
      ).unwrap();
      if (response?.data) {
        const url = response?.data?.url;
        if (url) {
          window.location.href = url;
        }
      }
    } catch (error: any) {
      console.log(error.response?.data?.error || error.message);
      dispatch<any>(
        setToast({
          message: error.response?.data?.error || error.message,
          type: "error",
          title: "Error",
          onClose: () => {},
        }),
      );
    } finally {
      setBtnLoading(false);
    }
  };

  useEffect(() => {
    if (
      data?.account?.account_id &&
      page === "setup" &&
      data?.invoices?.length
    ) {
      setPage("setup");
    }
  }, [data, page]);

  useEffect(() => {
    // Show loader for 6 seconds if code exists in URL
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (code) {
      setStripeCodeLoader(true);
      // const timeout = setTimeout(() => {
      //   setStripeCodeLoader(false);
      // }, 10000);
      // return () => clearTimeout(timeout);
    }
  }, []);

  // Extract data from the URL after STRIPE success
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");
  const state = params.get("state");
  const fetch = async () => {
    if (code) {
      await dispatch<any>(sendStripeCode({ code, state })).then(
        async (res: any) => {
          console.log("planssss");
          if (res?.payload?.code === 400 || res?.payload?.code === 422) {
            dispatch<any>(
              setToast({
                message: res?.payload?.message || "Something went wrong!",
                type: "error",
                title: "Error",
                onClose: () => {},
              }),
            );
          }
          const plansResponse = await dispatch<any>(getInvoicePlans()).unwrap();
          setPlans(plansResponse?.data);
          const response = await dispatch<any>(
            getInvoiceList({ offset: 0, search: "", filter_by: -1 }),
          ).unwrap();
          const resp = await dispatch<any>(
            getCustomInvoices({ offset: 0, limit: 10, search: "" }),
          ).unwrap();
          if (
            response?.data?.step === -1 &&
            !response?.data?.has_invoice_plan
          ) {
            setIsPending(true);
            return;
          }
          if (
            response?.data?.account?.account_id &&
            resp?.data?.length &&
            window.location.pathname.includes("/tools/invoices")
          ) {
            navigate("/tools/invoices/setup");
          }
          if (
            response?.data?.account?.account_id &&
            response?.data?.invoices?.length &&
            window.location.pathname.includes("/tools/invoices")
          ) {
            setPage("table");
            navigate("/tools/invoices/setup");
          } else if (
            res?.payload?.data?.account_id &&
            !res?.payload?.data?.has_invoices &&
            window.location.pathname.includes("/tools/invoices")
          ) {
            setPage("no-invoice");
            navigate("/tools/invoices/");
          }
        },
      );
    } else {
      const response = await dispatch<any>(
        getInvoiceList({ offset: 0, search: "", filter_by: -1 }),
      ).unwrap();
      const plansResponse = await dispatch<any>(getInvoicePlans()).unwrap();
      setPlans(plansResponse?.data);
      const customInvoiceResponse = await dispatch<any>(
        getCustomInvoices({ offset: 0, limit: 10, search: "" }),
      ).unwrap();
      if (response?.data?.step === -1 && !response?.data?.has_invoice_plan) {
        setIsPending(true);
        return;
      }
      if (response?.data?.subscription_count > 0) {
        setIsRenew(true);
      }
      if (!response?.data?.has_invoice_plan) {
        return;
      }
      if (
        (customInvoiceResponse?.data?.length ||
          response?.data?.has_invoice_plan) &&
        window.location.pathname.includes("/tools/invoices")
      ) {
        navigate("/tools/invoices/setup");
      }
      if (
        response?.data?.account?.account_id &&
        response?.data?.invoices?.length &&
        window.location.pathname.includes("/tools/invoices")
      ) {
        setPage("table");
        navigate("/tools/invoices/setup");
      } else if (
        response?.data?.account?.account_id &&
        !response?.data?.has_invoices &&
        window.location.pathname.includes("/tools/invoices")
      ) {
        setPage("no-invoice");
        navigate("/tools/invoices/no-invoice");
      } else {
        setPage("setup");
      }
    }
  };

  useEffect(() => {
    fetch();
  }, [dispatch, navigate]);

  useEffect(() => {
    return () => {
      isActive.current = false;
    };
  }, []);

  useEffect(() => {
    let interval: any;

    if (isPending) {
      // start polling every 10 seconds
      interval = setInterval(() => {
        fetch(); // your API call
      }, 10000);
    }

    // cleanup when isPending changes or component unmounts
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isPending]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  if (loading || stripeCodeLoader) {
    return <ListLoadingNew />;
  }

  if (!isActive.current) return <div></div>;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        padding: isMobile ? 0 : 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          maxHeight: "100%",
          width: "100%",
          padding: isMobile ? 0 : 2,
          bgcolor: "white",
          marginTop: 1,
          paddingTop: isMobile ? 2 : 7,
          paddingBottom: 5,
          borderRadius: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "100%",
          }}
        >
          <img
            src={Image}
            alt="Invoices"
            style={{
              maxWidth: isLargeScreen ? "200px" : "256px",
              height: isLargeScreen ? "210px" : "268px",
            }}
          />
          <div
            style={{
              marginTop: isMobile ? "20px" : "28px",
              display: "grid",
              padding: isMobile ? "0 12px" : "0",
              justifyItems: "center",
            }}
          >
            <p
              style={{
                fontSize: isMobile ? "16px" : isTablet ? "20px" : "28px",
                fontWeight: 700,
                textAlign: "center",
                margin: 0,
                width: isMobile ? "300px" : isTablet ? "500px" : "700px",
              }}
            >
              {isRenew
                ? "No active subscription found"
                : "Start sending invoices, aka online payment links to receive payments with ease."}
            </p>
            <p
              style={{
                fontSize: isMobile ? "12px" : isTablet ? "15px" : "16px",
                color: "#6C6F71",
                width: isMobile ? "100%" : isTablet ? "400px" : "528px",
                textAlign: "center",
                marginTop: isMobile ? 8 : 10,
                margin: isMobile ? "8px 0 0 0" : "10px 0 0 0",
              }}
            >
              {isRenew
                ? "You no longer have access to premium features. To continue sending invoices and receiving payments, please reactivate your subscription."
                : "Customize Your Invoice With Ease with Any Details you want"}
            </p>
            {!isPending && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 4,
                  width: "275px",
                  margin: "auto",
                  borderRadius: "12px",
                  backgroundColor: "#EAF1FA66",
                  padding: "6px 18px",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      textAlign: "left",
                      width: "100%",
                      fontWeight: 400,
                      marginTop: 10,
                    }}
                  >
                    Price
                  </span>
                  {plans?.length && (
                    <span
                      style={{
                        fontSize: "30px",
                        textAlign: "left",
                        width: "100%",
                        fontWeight: 700,
                        color: "#2977CC",
                      }}
                    >
                      ${plans?.length ? plans[0]?.unit_amount / 100 : "0"}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: 500,
                        }}
                      >
                        /{plans[0]?.recurring?.interval || "year"}
                      </span>
                    </span>
                  )}
                </div>
                <div
                  style={{
                    border: "0.2px solid #A7C7EA",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    padding: "5px 20px",
                  }}
                >
                  <BatchCardIcon />
                </div>
              </Box>
            )}
            {!isPending && (
              <button
                style={{
                  margin: "auto",
                  paddingTop: isMobile ? "12px" : "16px",
                  paddingBottom: isMobile ? "12px" : "16px",
                  paddingLeft: isMobile ? "24px" : "70px",
                  paddingRight: isMobile ? "24px" : "70px",
                  borderRadius: "8px",
                  background: btnLoading
                    ? "#BDBDBD"
                    : "linear-gradient(to right, #2977CC, #1D538F)",
                  color: "white",
                  border: "none",
                  fontSize: isMobile ? "14px" : "16px",
                  fontWeight: 600,
                  marginTop: isMobile ? "16px" : "22px",
                  cursor: "pointer",
                  minWidth: isMobile ? "140px" : "auto",
                  height: "54px",
                  opacity: btnLoading ? 0.7 : 1,
                }}
                onClick={() => {
                  // if (!btnLoading) {
                  //   navigate("/tools/invoices/setup");
                  // }
                  handleBuyPlan(plans[0]?.id);
                }}
                disabled={btnLoading}
              >
                {btnLoading ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  </span>
                ) : (
                  "Buy Now"
                )}
              </button>
            )}
            {isPending && (
              <div
                style={{
                  //fontSize: "14px",
                  fontWeight: 500,
                  margin: "auto",
                  marginTop: isMobile ? "16px" : "22px",
                  background: "#BDBDBD30",
                  paddingTop: isMobile ? "12px" : "14px",
                  paddingBottom: isMobile ? "12px" : "14px",
                  paddingLeft: isMobile ? "24px" : "25px",
                  paddingRight: isMobile ? "24px" : "25px",
                  borderRadius: "8px",
                  color: "red",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                Your subscription payment is being processed. Please wait a
                moment.
                <CircularProgress size={20} />
              </div>
            )}
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default InvoicePlanPage;
